import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

const ImpersonationModal = ({  formState, expirationDate }) => {
      const { getInputProps } = formState;
  return (
    <>
        <Message>
        Are you sure you want to delete the personal preference?
      </Message>
      <Form.Group controlId="expirationDate">
        <Form.Label>By default the expiration date is 30 days from now. If you want, you can change it below.</Form.Label>
        <Form.Control
            type="date"
            value={expirationDate}
            {...getInputProps('expirationDate')}
            min={new Date().toISOString().split("T")[0]}
        />
        </Form.Group>
    </>
  );
};

const Message = styled.div`
    margin-bottom: 1rem;
    font-weight: bold;
    font-size: 1.1rem;
    border-bottom-color: rgb(221, 226, 235);
    border-bottom-width: 0.1rem;
}
`;

export default ImpersonationModal;
